const WHATSAPP_NUMBER = "5491130473057";
const DEFAULT_MESSAGE = "Hola, Coressen, estuve viendo la web, quiero contactarme con un consultor.";

export const getWhatsAppLink = (message: string = DEFAULT_MESSAGE): string => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

export const WHATSAPP_URL = getWhatsAppLink();
